<template>
	<div class="loading">
		<div class="loading-mask">
			<div class="loading-spinner">
				<svg class="circular" viewBox="25 25 50 50">
					<circle class="path" cx="50" cy="50" r="20" fill="none"></circle>
				</svg>
				<p class="loading-text">loading ....</p>
				<p class="loading-text">{{ tip }}</p>
				
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		props: {
			tip: {
				type: String,
				default  (){
					return this.$t('other.a392')
				},
			},
		},
	}
</script>
<style scoped>
	.loading {
		position: relative !important;
		height: 50px;
	}

	/* from ElementUI Loading style */
	.loading-mask {
		position: absolute;
		z-index: 2000;
		/* background-color: hsla(0, 0%, 100%, 0.9); */
		background-color: #FFFFFF;
		margin: 0;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		/* transition: opacity 0.3s; */
	}

	.loading-spinner {
		top: 50%;
		margin-top: -25px;
		width: 100%;
		text-align: center;
		position: absolute;
	}

	.circular {
		height: 20px;
		width: 20px;
		animation: loading-rotate 2s linear infinite;
	}

	.path {
		animation: loading-dash 1.5s ease-in-out infinite;
		stroke-dasharray: 150, 150;
		stroke-dashoffset: 0;
		stroke-width: 2;
		stroke: #409eff;
		stroke-linecap: round;
	}

	@keyframes loading-rotate {
		100% {
			transform: rotate(1turn);
		}
	}

	@keyframes loading-dash {
		0% {
			stroke-dasharray: 1, 200;
			stroke-dashoffset: 0;
		}

		50% {
			stroke-dasharray: 90, 150;
			stroke-dashoffset: -40px;
		}

		100% {
			stroke-dasharray: 90, 150;
			stroke-dashoffset: -120px;
		}
	}

	.loading-text {
		color: #409eff;
		margin: 3px 0;
		font-size: 18px;
	}
</style>
